<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { Primitive, type PrimitiveProps } from 'radix-vue'
import { type ButtonVariants, buttonVariants } from '.'

interface Props extends PrimitiveProps {
	variant?: ButtonVariants['variant']
	size?: ButtonVariants['size']
	class?: HTMLAttributes['class']
	loading?: boolean
	disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
	as: 'button',
	loading: false,
	disabled: false,
})
</script>

<template>
	<primitive
		:as="as"
		:as-child="asChild"
		:class="cn(buttonVariants({ variant, size }), props.class)"
		:disabled="props.disabled || props.loading"
	>
		<template v-if="$slots.icon">
			<template v-if="!props.loading">
				<div class="flex items-center gap-2">
					<slot />
					<span class="transition-transform group-hover:translate-x-1.5">
						<slot name="icon" />
					</span>
				</div>
			</template>
		</template>
		<template v-else>
			<slot v-if="!props.loading" />
		</template>

		<i-ph-spinner-gap-bold v-if="props.loading" class="animate-spin" />
	</primitive>
</template>
